(function() {
    'use strict';


    angular.module('eclipseApp.myAccount').controller('lostStolenSuspendCtrl', ['$scope', '$state', 'lostStolenDeviceService', 'uteModal', '$stateParams', 'uteLocale','env','commonService', function($scope, $state, lostStolenDeviceService, uteModal, $stateParams, uteLocale,env,commonService) {

        $scope.upgradePhoneLink = null;

        $scope.hideEmail = false;

        $scope.customerEmail = lostStolenDeviceService.getContactEmail();
                if (_.isEmpty($scope.customerEmail)) {
                    $scope.hideEmail= true;
        }
        $scope.init = function() {
            $scope.ctn = lostStolenDeviceService.getSelectedFido();
            $scope.ban = lostStolenDeviceService.getAccountNumber();
            if (uteLocale.language === 'en') {
                $scope.deviceDetail = lostStolenDeviceService.getDeviceDetails().en;
                $scope.upgradePhoneLink = env.enUpgradePhoneLink;
            } else {
                $scope.deviceDetail = lostStolenDeviceService.getDeviceDetails().fr;
                $scope.upgradePhoneLink = env.frUpgradePhoneLink;
            }
        }
        $scope.suspendService = function() {
            uteModal.open({
                controller: 'suspendDeviceModalCtrl',
                templateUrl: 'modules/my-account/lost-stolen-device/lost-stolen-suspend-device-modal.html',
                data: {
                    ban : $scope.ban,
                    ctn : $scope.ctn
                },
                ok: function() {
                    console.log('OK');
                },
                cancel: function() {
                    console.log('CANCEL');
                }
            });

        }
        $scope.backToAccount = function() {
            $state.go("myAccount.overview");
        }

        $scope.cancel = function(){
        		  angular.forEach(commonService.accountDetails, function(accountDetail, value) {
                  if ($scope.ban === accountDetail.accountNumber) {
              		var lob = accountDetail.LOB ;
              		if(lob.toUpperCase() == "WL"){
                    $state.go('myAccount.wireless' , {'accountNumber':  $scope.ban , 'subscriberNo':   $scope.ctn });
                  }else {
                    $state.go('myAccount.prepaidWLDashboard' , {'accountNumber': $scope.ban, 'subscriberNo':   $scope.ctn });
                  }
              	}
              });
        }


        $scope.init();

    }]);
})();
